import React from "react";
import { Card, Container } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getAuthMethod } from "../../modules/helper";
import MainMenu from "../../modules/public/mainMenu/mainMenu";

class Driver extends React.Component {
  state = {
    data: [],
    partsdetails: [],
    id: "",
    status: "",
    answer: "",
    modalShow: false,
    showNumber: 10,
    pageNumber: 1,
    active: 1,
    paginationlength: 1,
    startNumber: 0,
    sendItem: "",
    print: false,
    itemprint: "",
    logo: "",
  };
  componentDidMount() {
    this.getData();
  }

  constructor(props) {
    super(props);
  }

  async getData() {
    const datas = await getAuthMethod(`/agent/v1/driver`);

    if (datas && datas.status === 200) {
      this.setState({
        data: datas.data.data,
        startNumber: 1,
      });
    }
  }

  render() {
    var table = (
      <div className="w-100 px-1 overflow-x-scroll">
        <Table striped bordered={true} className="text-center">
          <thead className="w-100">
            <tr>
              <th>#</th>
              <th>نام و نام خانوادگی</th>
              <th>شماره موبایل</th>
            </tr>
          </thead>
          <tbody>
            {this.state.data.map((user, index) => (
              <tr key={index}>
                <td>{index + this.state.startNumber}</td>
                <td>{user.name}</td>
                <td>{user.mobile}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );

    var total = (
      <Container className="d-flex flex-column justify-content-center  align-items-center ">
        <Card className="w-100">{table}</Card>
      </Container>
    );

    return <MainMenu data={total} />;
  }
}
const withRouter = Component => props => {
  const history = useNavigate();
  const location = useLocation();
  const params = useParams();
  return (
    <Component
      params={params}
      history={history}
      location={location}
      {...props}
    />
  );
};

export default withRouter(Driver);
